import { Optional } from '@vimeo/core/types/generic';

import { liveTrackingConfig } from '../configs/LiveTrackingConfig';
import { createLiveSchemaEventFactoryNew, TSchemaEventFactoryNew } from './helpers/utils';

/**
 * Engagement qna tracking.
 *
 * @link https://big-picture.vimeows.com/events/details/vimeo.live_engagement_qna
 */
const trackEngagementQna: TSchemaEventFactoryNew = createLiveSchemaEventFactoryNew(
  'vimeo.live_engagement_qna',
  6,
  () => ({
    ...liveTrackingConfig.BIG_PICTURE_INTERACTION_SCHEMA_BASE,
    isModerated: null,
    isInProgram: null,
    countQuestions: null,
  }),
);

export function trackViewQna(): void {
  return trackEngagementQna({ eventName: 'view_qna', eventType: 'impression' });
}

export function trackClickStartQna(isModerated: Optional<boolean>): void {
  return trackEngagementQna({ eventName: 'click_start_qna', isModerated });
}

export function trackClickEndQna(
  isModerated: Optional<boolean>,
  countQuestions: Optional<number>,
): void {
  return trackEngagementQna({ eventName: 'click_end_qna', isModerated, countQuestions });
}

export function trackApproveModeratedQuestion(): void {
  return trackEngagementQna({ eventName: 'approve_moderated_question' });
}

export function trackExportQna(): void {
  return trackEngagementQna({ eventName: 'export_qna' });
}

export function trackOpenQnaTab(): void {
  return trackEngagementQna({ eventName: 'open_qna_tab' });
}

export function trackArchiveQuestion(isModerated: Optional<boolean>): void {
  return trackEngagementQna({ eventName: 'archive_question', isModerated });
}

export function trackUnarchiveQuestion(isModerated: Optional<boolean>): void {
  return trackEngagementQna({ eventName: 'unarchive_question', isModerated });
}

export function trackSortByMostPopular(): void {
  return trackEngagementQna({ eventName: 'sort_by_most_popular' });
}

export function trackSortByMostRecent(): void {
  return trackEngagementQna({ eventName: 'sort_by_most_recent' });
}

export function trackSwitchActiveTab(): void {
  return trackEngagementQna({ eventName: 'switch_active_tab' });
}

export function trackRemoveQnaFromScene(): void {
  return trackEngagementQna({ eventName: 'remove_qna_from_scene' });
}

export function trackAddQnaToScene(): void {
  return trackEngagementQna({ eventName: 'add_qna_to_scene' });
}

export function trackAskQuestion(): void {
  return trackEngagementQna({ eventName: 'ask_question' });
}

export function trackShowQuestion(
  isModerated: Optional<boolean>,
  isInProgram: Optional<boolean>,
  location: Optional<string>,
): void {
  return trackEngagementQna({ eventName: 'show_question', isModerated, isInProgram, location });
}

export function trackHideQuestion(isModerated: Optional<boolean>, location: string): void {
  return trackEngagementQna({ eventName: 'hide_question', isModerated, location });
}

export function trackSelectQuestion(): void {
  return trackEngagementQna({ eventName: 'select_question' });
}

export function trackReplyQuestion(): void {
  return trackEngagementQna({ eventName: 'reply_question' });
}

export function trackReplyAndApproveQuestion(): void {
  return trackEngagementQna({ eventName: 'reply_and_approve_question' });
}

export function trackDeleteQuestionReply(): void {
  return trackEngagementQna({ eventName: 'delete_response' });
}

export function trackPinQuestion(): void {
  return trackEngagementQna({ eventName: 'pin_question' });
}

export function trackUnpinQuestion(): void {
  return trackEngagementQna({ eventName: 'unpin_question' });
}
